import { AHButton } from "./AHButton";
import { AHText } from "./Text/AHText";
import { Box } from "./AHTheme/Box";
import React from "react";

export const AHQueryHandlerError = ({
  title,
  retryButtonTitle,
  ...props
}: {
  isLoading: boolean;
  onPress?: () => void;
  title?: string;
  retryButtonTitle?: string;
}) => {
  return (
    <Box
      spaceHorizontal="medium"
      style={{
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <AHText spaceBottom="medium" type="title-small">
        {title ?? "Unknown Error"}
      </AHText>

      {props.onPress ? (
        <AHButton
          loading={props.isLoading}
          onPress={props.onPress}
          themeType="primary"
          title={retryButtonTitle ?? "Retry"}
        />
      ) : null}
    </Box>
  );
};

function AHQueryHandlerErrorFallback({
  resetErrorBoundary,
}: {
  error: Error;
  resetErrorBoundary: () => void;
}) {
  return <AHQueryHandlerError isLoading={false} onPress={resetErrorBoundary} />;
}

export function AHQueryHandlerErrorFallbackStatic({}: { error: Error }) {
  return <AHQueryHandlerError isLoading={false} />;
}
